var hasPermission = require('../methods/has-permission');

module.exports = function(h) {
    var actionButtons = [];
    var buttons = [];
    var desktopLinks = [];
    var mobileButtons = [];
    var mobileLinks = [];
    var deleteBtn;

    // Add old settings compatibility
    var createBtn = !_.isEmpty(this.options.create_btn)
        ? this.options.create_btn
        : null;

    const permission =
        typeof this.opts.permission.create === 'function'
            ? this.opts.permission.create()
            : this.opts.permission.create;

    if (!_.isNull(createBtn) && hasPermission.call(this, permission)) {
        actionButtons.push({
            title: createBtn.title,
            action: createBtn.action,
        });
    }

    this.opts.actionButtons.forEach(btn => actionButtons.push(btn));

    // Add old settings compatibility
    if (this.options.csv_url || this.options.pdf_url) {
        var exportList = {
            title: 'Export',
            action: [],
        };

        if (this.options.csv_url) {
            exportList.action.push({
                title: 'CSV',
                callback: () =>
                    window.open(
                        `${this.options.csv_url}?${this.getQueryParams()}`,
                    ),
            });
        }

        if (this.options.xls_url) {
            exportList.action.push({
                title: 'XLSX',
                callback: () =>
                    window.open(
                        `${this.options.xls_url}?${this.getQueryParams()}`,
                    ),
            });
        }

        if (this.options.pdf_url) {
            exportList.action.push({
                title: 'PDF',
                callback: () =>
                    window.open(
                        `${this.options.pdf_url}?${this.getQueryParams()}`,
                    ),
            });
        }

        actionButtons.push(exportList);
    }

    if (Array.isArray(actionButtons)) {
        // desktop buttons
        actionButtons.forEach(btn => {
            var link;
            var dropdownList = [];

            if (!Array.isArray(btn.action)) {
                link = (
                    <li class="nav-item inline p-l-sm pull-right">
                        <a
                            class="btn btn-fw white"
                            title={btn.title}
                            onClick={btn.action}
                        >
                            {btn.title}
                        </a>
                    </li>
                );
            } else {
                // loop btn actions
                btn.action.forEach(action => {
                    dropdownList.push(
                        <a class="dropdown-item" onClick={action.callback}>
                            {action.title}
                        </a>,
                    );
                });

                link = (
                    <li
                        class="nav-item inline p-l-sm dropdown pull-right"
                        data-toggle="dropdown"
                    >
                        <a
                            class="btn btn-fw white dropdown-toggle"
                            data-toggle="dropdown"
                        >
                            {btn.title}
                        </a>
                        <div class="dropdown-menu dropdown-menu-scale pull-right">
                            {dropdownList}
                        </div>
                    </li>
                );
            }

            desktopLinks.push(link);
        });

        buttons.push(
            <ul class="nav pull-right VueTables__action-buttons">
                {desktopLinks}
            </ul>,
        );

        // mobile buttons
        var i = 0;
        actionButtons.forEach(btn => {
            i++;

            var link;
            var dropdownList = [];

            if (!Array.isArray(btn.action)) {
                link = (
                    <a
                        class="dropdown-item"
                        title={btn.title}
                        onClick={btn.action}
                    >
                        {btn.title}
                    </a>
                );
            } else {
                // loop btn actions
                btn.action.forEach(action => {
                    dropdownList.push(
                        <a class="dropdown-item" onClick={action.callback}>
                            {action.title}
                        </a>,
                    );
                });

                mobileLinks.push(
                    <span class="dropdown-header">Export As</span>,
                );
                link = dropdownList;
            }

            mobileLinks.push(link);

            if (i < actionButtons.length) {
                mobileLinks.push(<div class="dropdown-divider" />);
            }
        });

        mobileButtons.push(
            <ul class="nav pull-right VueTables__action-list">
                <li class="nav-item inline dropdown">
                    <a
                        class="nav-link text-muted p-x-xs"
                        data-toggle="dropdown"
                        aria-expanded="true"
                    >
                        <i class="fa fa-ellipsis-v" />
                    </a>
                    <div class="dropdown-menu dropdown-menu-scale pull-right">
                        {mobileLinks}
                    </div>
                </li>
            </ul>,
        );
    }

    return {
        desktop: buttons,
        mobile: mobileButtons,
    };
};



// WEBPACK FOOTER //
// ./resources/assets/js/plugins/vuetable2-checkbox/modules/action-buttons.jsx